export enum BoostOfferStatus {
	NotActivated = 'NotActivated',
	Activated = 'Activated',
	Redeemed = 'Redeemed',
}
